import { render, staticRenderFns } from "./vaccinations.vue?vue&type=template&id=d5a56b24&scoped=true"
import script from "./vaccinations.vue?vue&type=script&lang=js"
export * from "./vaccinations.vue?vue&type=script&lang=js"
import style0 from "./vaccinations.vue?vue&type=style&index=0&id=d5a56b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a56b24",
  null
  
)

export default component.exports